export const PageData = {
    introduction: [
    {
        heading: "Introduction",
        id: 1,
        text: [
            {
                id: 1,
                subtitle: "Opening: ",
                body: "The United States is home to some of the world's best universities, attracting students from all over the globe. If you're interested in pursuing your education in the U.S., the first step is obtaining the right student visa.",
            },
            {
                id: 2,
                subtitle: "Goal: ",
                body: "This guide will help you understand the types of student visas, the application process, and how GIT Global can assist you in fulfilling your dream of studying in the U.S.",
            },
        ]
    },
    {
        heading: "Types of U.S. Student Visas",
        id: 2,
        text: [
            {
                id: 1,
                subtitle: "F-1 Visa: ",
                body: "For academic studies at an accredited U.S. college, university, or high school. It’s the most common student visa.",
            },
            {
                id: 2,
                subtitle: "M-1 Visa: ",
                body: "For vocational or non-academic programs, such as technical schools or specialized training.",
            },
            {
                id: 3,
                subtitle: "J-1 Visa: ",
                body: "For students participating in exchange programs, internships, or specific training programs.",
            },
        ]
    },
    ],
    howToApply: [
        {
            heading: "Step-by-Step Guide to Applying for a U.S. Student Visa",
            id: 1,
            procedures: [
                {
                    title: "Step 1: Get Accepted by a SEVP-Approved School",
                    id: 1,
                    steps: [
                        {
                            id: 1,
                            text: "Before applying for a visa, you must first be accepted into a school approved by the Student and Exchange Visitor Program (SEVP). Once accepted, you will receive a Form I-20 (for F-1 or M-1 visas) or Form DS-2019 (for J-1 visas).",
                        },
                    ],
                    tips: [
                        {
                            title: "Tip: ",
                            id: 1,
                            body: "Include advice on researching schools, the importance of accreditation, and ensuring the school is SEVP-approved.",
                        },
                    ],
                },
                {
                    title: "Step 2: Pay the SEVIS Fee",
                    id: 2,
                    steps: [
                        {
                            id: 1,
                            text: "After receiving your Form I-20 or DS-2019, you must pay the SEVIS I-901 fee to enroll in the Student and Exchange Visitor Information System (SEVIS).",
                        },
                        {
                            id: 2,
                            text: "Provide a link or instructions on how to pay the SEVIS fee.",
                        },
                    ],
                    tips: [],
                },
                {
                    title: "Step 3: Complete the Visa Application (Form DS-160)",
                    id: 3,
                    steps: [
                        {
                            id: 1,
                            text: "To apply for your student visa, complete the DS-160 (Online Nonimmigrant Visa Application) and print the confirmation page.",
                        },
                    ],
                    tips: [],
                },
                {
                    title: "Important Documents Needed:",
                    id: 4,
                    steps: [
                        {
                            id: 1,
                            text: "Passport (valid for at least 6 months beyond your intended stay).",
                        },
                        {
                            id: 2,
                            text: "Recent passport photo (that meets U.S. visa photo requirements).",
                        },
                        {
                            id: 3,
                            text: "Form I-20 (F-1/M-1) or DS-2019 (J-1).",
                        },
                        {
                            id: 4,
                            text: "SEVIS I-901 fee receipt.",
                        },
                        {
                            id: 5,
                            text: "Proof of financial support to show you can cover tuition, living expenses, and other costs while studying in the U.S.",
                        },
                    ],
                    tips: [],
                },
                {
                    title: "Step 4: Schedule and Attend Your Visa Interview",
                    id: 5,
                    steps: [
                        {
                            id: 1,
                            text: "After completing the DS-160, schedule an interview at the U.S. embassy or consulate in your country. The interview is a critical step in obtaining your visa.",
                        },
                    ],
                    tips: [],
                },
                {
                    title: "Tips for Your Interview:",
                    id: 6,
                    steps: [
                        {
                            id: 1,
                            text: "Be prepared to explain why you want to study in the U.S., your educational background, and how you will finance your education.",
                        },
                        {
                            id: 2,
                            text: "Bring all required documents, including financial records, academic transcripts, and acceptance letters.",
                        },
                        {
                            id: 3,
                            text: "GIT Global helps applicants prepare for their visa interview.",
                        },
                    ],
                    tips: [],
                },
                {
                    title: "Step 5: Receive Your Visa Decision",
                    id: 7,
                    steps: [
                        {
                            id: 1,
                            text: "After the interview, your visa will either be approved, denied, or you may be asked to provide additional documentation.",
                        },
                        {
                            id: 2,
                            text: "Explain the timeline for visa issuance and when you can expect to receive your visa and travel to the U.S.",
                        },
                    ],
                    tips: [],
                },
            ]
        },
    ],
    afterApplication: [
        {
            heading: "What to Do After You Get Your Visa",
            id: 1,
            text: [
                {
                    id: 1,
                    subtitle: "Travel to the U.S.: ",
                    body: "Once your visa is approved, you can make travel arrangements. You are allowed to enter the U.S. up to 30 days before your program starts.",
                },
                {
                    id: 2,
                    subtitle: "Maintaining Your Student Status: ",
                    body: "Discuss the importance of maintaining your visa status, including attending classes regularly, not working without authorization, and following SEVIS guidelines.",
                },
            ]
        },
        {
            heading: "Common Reasons for Visa Denial and How to Avoid Them",
            id: 2,
            text: [
                {
                    id: 1,
                    subtitle: "Insufficient Financial Support: ",
                    body: "Explain how demonstrating sufficient funds is key to a successful application.",
                },
                {
                    id: 2,
                    subtitle: "Inaccurate or Missing Documentation: ",
                    body: "Emphasize the importance of having all required documents ready and how GIT Global can help applicants avoid common mistakes.",
                },
            ]
        },
        {
            heading: "How GIT Global Can Help You with Your Student Visa Application",
            id: 3,
            text: [
                {
                    id: 1,
                    subtitle: "Personalized Assistance: ",
                    body: "GIT Global offers guidance through each step of the student visa process, from filling out your DS-160 form to preparing for the visa interview.",
                },
                {
                    id: 2,
                    subtitle: "Document Review: ",
                    body: "We help ensure that all required documents are complete and error-free, reducing the risk of delays or denials.",
                },
                {
                    id: 3,
                    subtitle: "Visa Interview Preparation: ",
                    body: "Our team offers one-on-one coaching to prepare you for the visa interview, helping you feel confident and ready.",
                },
            ]
        },
    ],
    
}
